import {showMore} from "./module/showmore";

$(function(){
	showMore('.js-show-contents', 9);
})
